import React from "react";
 
import { ReactComponent as AddIcon } from "common/assets/svg/plus.svg";
import { ReactComponent as SubIcon } from "common/assets/svg/minus.svg";
import "./styles.css";
 
export interface ItemCountSpinnerProps {
  count: number;
  onPressIncrement: any;
  onPressDecrement: any;
  size: string;
  decrementDisabled: boolean;
  forspecial?:boolean
}
 
function ItemCountSpinner(props: ItemCountSpinnerProps) {
  return (
    <div
      id={
        props.size == "small" || props.size == "medium"
          ? "spinner-container-small"
          : "spinner-container"
      }
      className={props.size == "medium" ? ".spinner-container-medium" : ""}
    >
      <div className={`item-count-pos ${props.forspecial?"exclusive-menu-spinner":""}`}  >
        <span
        onClick={() => props.onPressDecrement()}
        style={{opacity:props.decrementDisabled ? 0.3:1, }}
      >
        <SubIcon className="item-count-svg" />
      </span>
      <span className="item-count-value">
        {props.count <= 9 ? "0" + props.count : props.count}
      </span>
      <span onClick={() => props.onPressIncrement()}  >
        <AddIcon className="item-count-svg" />
      </span>
      </div>
    </div>
  );
}
export default ItemCountSpinner;